import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const ThemeContext = createContext(null);

const PRESETS = [
    { label: "Safety Orange", hsl: "24.6 95% 53.1%" },
    { label: "Industrial Red", hsl: "0 84% 55%" },
    { label: "Turbine Cyan", hsl: "187 85% 43%" },
    { label: "Voltage Yellow", hsl: "45 95% 50%" },
    { label: "Forge Green", hsl: "142 65% 40%" },
    { label: "Graphite", hsl: "222 47% 11%" },
    { label: "Magenta Flare", hsl: "330 85% 55%" },
];

export function ThemeProvider({ children }) {
    const [primaryHsl, setPrimaryHsl] = useState("24.6 95% 53.1%");

    useEffect(() => {
        (async () => {
            try {
                const { data } = await api.get("/theme");
                setPrimaryHsl(data.primary_hsl);
            } catch {}
        })();
    }, []);

    useEffect(() => {
        document.documentElement.style.setProperty("--theme-primary", primaryHsl);
    }, [primaryHsl]);

    const updateTheme = async (hsl) => {
        setPrimaryHsl(hsl);
        try {
            await api.put("/theme", { primary_hsl: hsl });
        } catch {}
    };

    return (
        <ThemeContext.Provider value={{ primaryHsl, setPrimaryHsl, updateTheme, presets: PRESETS }}>
            {children}
        </ThemeContext.Provider>
    );
}

export function useTheme() {
    const ctx = useContext(ThemeContext);
    if (!ctx) throw new Error("useTheme must be used within ThemeProvider");
    return ctx;
}
